import { isAxiosError } from "axios";

export function getCertificationRequestError(error: unknown, fallback: string): string {
  if (isAxiosError(error)) {
    const message = error.response?.data?.message;
    if (typeof message === "string" && message.trim() !== "") return message;
    const errors = error.response?.data?.errors;
    if (errors && typeof errors === "object") {
      const first = Object.values(errors).flat().find((value) => typeof value === "string");
      if (typeof first === "string") return first;
    }
  }
  return fallback;
}
